(() => {
  if (window.toastyHeaderNavigationReady) return;
  window.toastyHeaderNavigationReady = true;
  const selector = '[data-toasty-navigation] .toasty-header-menu';
  const desktop = matchMedia('(min-width: 990px)');
  const desktopViewport = desktop;
  const closeTimers = new WeakMap();
  const labelFor = menu => menu.closest('[data-toasty-menu-item]')?.querySelector(':scope > a.toasty-header-pill');
  const itemFor = target => target?.closest?.('[data-toasty-menu-item]');
  const closeMenus = (scope = document, except = null) => {
    scope.querySelectorAll(`${selector}[open]`).forEach(menu => {
      if (menu !== except) menu.open = false;
    });
  };
  document.addEventListener('toggle', event => {
    const menu = event.target;
    if (!menu.matches?.(selector)) return;
    menu.querySelector('summary').setAttribute('aria-expanded', String(menu.open));
    labelFor(menu)?.setAttribute('aria-expanded', String(menu.open));
    if (menu.open) closeMenus(menu.closest('[data-toasty-navigation]'), menu);
  }, true);
  document.addEventListener('pointerover', event => {
    if (desktop.matches && event.pointerType === 'mouse' && !event.target.closest?.('.site-header')) closeMenus();
    const item = itemFor(event.target);
    const menu = item?.querySelector('.toasty-header-menu');
    if (!menu || !desktop.matches || event.pointerType !== 'mouse' || menu.closest('.toasty-header-nav--mobile')) return;
    clearTimeout(closeTimers.get(menu));
    if (item.contains(event.relatedTarget)) return;
    menu.open = true;
  });
  document.addEventListener('pointerout', event => {
    const item = itemFor(event.target);
    const menu = item?.querySelector('.toasty-header-menu');
    if (!menu || !desktop.matches || menu.closest('.toasty-header-nav--mobile') || item.contains(event.relatedTarget) || item.contains(document.activeElement)) return;
    const header = menu.closest('.site-header');
    if (header?.contains(event.relatedTarget)) return;
    closeTimers.set(menu, setTimeout(() => {
      if (!item.contains(document.activeElement)) menu.open = false;
    }, 180));
  });
  document.addEventListener('focusout', event => {
    const item = itemFor(event.target);
    const menu = item?.querySelector('.toasty-header-menu');
    if (menu && !menu.closest('.toasty-header-nav--mobile') && !item.contains(event.relatedTarget)) menu.open = false;
  });
  document.addEventListener('pointerdown', event => {
    if (!event.target.closest?.('[data-toasty-navigation]')) closeMenus();
  });
  document.addEventListener('keydown', event => {
    const item = itemFor(event.target);
    const disclosure = item?.querySelector('.toasty-header-menu');
    if (desktopViewport.matches && disclosure && event.target === labelFor(disclosure) && ['ArrowDown', ' '].includes(event.key)) {
      disclosure.open = true;
      disclosure.querySelector('.toasty-header-panel a')?.focus();
      event.preventDefault();
      return;
    }
    if (event.key !== 'Escape') return;
    const menu = itemFor(event.target)?.querySelector('.toasty-header-menu[open]');
    if (!menu) return;
    menu.open = false;
    (desktopViewport.matches && labelFor(menu) || menu.querySelector('summary')).focus();
    event.preventDefault();
  });
  desktop.addEventListener('change', () => closeMenus());
  const reducedMotion = matchMedia('(prefers-reduced-motion: reduce)');
  let homeNavigation;
  const resetHomeNavigation = () => {
    if (!homeNavigation) return;
    clearTimeout(homeNavigation.timer);
    homeNavigation.animation.cancel();
    homeNavigation = null;
  };
  const finishHomeNavigation = expected => {
    if (!homeNavigation || (expected && homeNavigation !== expected)) return;
    const destination = homeNavigation.destination;
    resetHomeNavigation();
    location.assign(destination);
  };
  document.addEventListener('click', event => {
    const link = event.target.closest?.('a[data-toasty-home-logo]');
    if (!link || event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || link.hasAttribute('download') || (link.target && link.target !== '_self')) return;
    if (homeNavigation) {
      event.preventDefault();
      return;
    }
    const artwork = link.querySelector('img, svg');
    if (reducedMotion.matches || !artwork?.animate) return;
    let animation;
    try {
      animation = artwork.animate([
        { transform: 'perspective(500px) rotateY(0deg)' },
        { transform: 'perspective(500px) rotateY(360deg)' }
      ], { duration: 300, easing: 'linear' });
    } catch {
      return;
    }
    event.preventDefault();
    const navigation = { animation, destination: link.href };
    homeNavigation = navigation;
    navigation.timer = setTimeout(() => finishHomeNavigation(navigation), 320);
    animation.finished.then(() => finishHomeNavigation(navigation), () => {});
  });
  reducedMotion.addEventListener('change', () => {
    if (reducedMotion.matches) finishHomeNavigation();
  });
  window.addEventListener('pagehide', resetHomeNavigation);
  window.addEventListener('pageshow', resetHomeNavigation);
  // Keep the homepage navigation within the image, without changing internal-page headers.
  const setupHeroHeader = () => {
    const header = document.querySelector('[data-toasty-hero-header]');
    const art = document.querySelector('.tt12-hero__art');
    if (!header || !art || header.hasAttribute('data-hero-scroll-ready')) return;
    header.setAttribute('data-hero-scroll-ready', '');
    let frame;
    let wasPast = false;
    const update = () => {
      frame = null;
      const bottom = art.getBoundingClientRect().bottom;
      const height = header.getBoundingClientRect().height;
      const past = bottom <= 0;
      header.style.setProperty('--toasty-hero-header-y', `${Math.max(-height, Math.min(0, bottom - height - (parseFloat(getComputedStyle(header).top) || 0)))}px`);
      header.toggleAttribute('data-hero-past', past);
      header.inert = past;
      if (past && !wasPast) {
        closeMenus(header);
        header.dispatchEvent(new CustomEvent('toasty:hero-header-hidden'));
        if (header.contains(document.activeElement)) document.getElementById('MainContent')?.focus({ preventScroll: true });
      }
      wasPast = past;
    };
    const schedule = () => { if (!frame) frame = requestAnimationFrame(update); };
    window.addEventListener('scroll', schedule, { passive: true });
    window.addEventListener('resize', schedule);
    const observer = 'ResizeObserver' in window ? new ResizeObserver(schedule) : null;
    observer?.observe(art);
    observer?.observe(header);
    update();
    header.closest('.shopify-section')?.addEventListener('shopify:section:unload', () => {
      window.removeEventListener('scroll', schedule);
      window.removeEventListener('resize', schedule);
      observer?.disconnect();
      if (frame) cancelAnimationFrame(frame);
    }, { once: true });
  };
  setupHeroHeader();
  document.addEventListener('shopify:section:load', setupHeroHeader);

  const setupAnnouncements = () => {
    document.querySelectorAll('[data-toasty-announcements]').forEach(bar => {
      if (bar.dataset.ready) return;
      bar.dataset.ready = 'true';
      const track = bar.querySelector('.toasty-announcements__track');
      const group = bar.querySelector('.toasty-announcements__group');
      const measure = () => track.style.setProperty('--announcement-duration', `${group.getBoundingClientRect().width / (Number(bar.dataset.speed) || 40)}s`);
      const observer = 'ResizeObserver' in window ? new ResizeObserver(measure) : null;
      observer?.observe(group);
      measure();
      // Restore the starting position after keyboard/manual browsing.
      bar.addEventListener('focusout', event => {
        if (!bar.contains(event.relatedTarget)) bar.querySelector('.toasty-announcements__viewport').scrollLeft = 0;
      });
      bar.closest('.shopify-section')?.addEventListener('shopify:section:unload', () => observer?.disconnect(), { once: true });
    });
  };
  setupAnnouncements();
  document.addEventListener('shopify:section:load', setupAnnouncements);

  // The native drawer teleports its contents after this script runs.
  // Initialize on connection so long names wrap on the first menu opening.
  if (window.customElements && !customElements.get('toasty-mobile-country')) {
    customElements.define('toasty-mobile-country', class extends HTMLElement {
      connectedCallback() {
        const select = this.querySelector('select');
        const text = this.querySelector('.toasty-mobile-menu__country-text');
        if (!select || !text) return;
        const update = () => {
          const name = (select.selectedOptions[0]?.textContent || '').trim();
          const parts = name.match(/^(.*) (\([^()]+\))$/);
          text.textContent = name;
          if (parts) {
            const currency = document.createElement('span');
            currency.className = 'toasty-mobile-menu__country-currency';
            currency.textContent = parts[2];
            text.replaceChildren(document.createTextNode(`${parts[1]} `), currency);
          }
          text.hidden = false;
        };
        if (!select.hasAttribute('data-country-text-ready')) {
          select.setAttribute('data-country-text-ready', '');
          select.addEventListener('change', update);
          select.addEventListener('input', update);
        }
        update();
      }
    });
  }

})();
